import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { PropsWithChildren } from 'react';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    before_send: (event) => {
      const url = event?.properties?.$current_url;
      if (
        window.location.pathname.startsWith('/p/') ||
        (typeof url === 'string' && /\/p\//.test(url))
      )
        return null;
      return event;
    },
  });
}

export { posthog };

export function CSPostHogProvider({ children }: PropsWithChildren) {
  if (!posthogKey) return <>{children}</>;

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
